import React, { useContext, useMemo } from "react";
import { Col, Row } from "react-bootstrap";

import { AchFeesFields } from "globalConstants";

import FeeBlockContext from "../feeBlockContext";
import FeesTemplateContext from "../feesTemplateContext";
import TemplateField from "../templateField";

import styles from "./feesAch.module.scss";

const FeesAchFields = ({
	isEntryApplication = false,
}: {
	isEntryApplication?: boolean;
}) => {
	const {
		validators,
		application: { isPaperApplication },
	} = useContext(FeesTemplateContext);

	const placeholderClassName = useMemo(
		() =>
			isPaperApplication ? "placeholder-value" : "placeholder-primary",
		[isPaperApplication],
	);

	return (
		<FeeBlockContext.Provider value="AchFees">
			{!isEntryApplication && <p className={styles.header}>ACH Fees</p>}
			<Row>
				<Col md={5}>
					<TemplateField
						name={AchFeesFields.SetupFee.name}
						label={`${AchFeesFields.SetupFee.displayName}, $`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeeCurrency}
						hideRequiredMark={isPaperApplication}
					/>
					<TemplateField
						name={AchFeesFields.TransactionFee.name}
						label={`${AchFeesFields.TransactionFee.displayName}, $`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeeCurrency}
						hideRequiredMark={isPaperApplication}
					/>
					<TemplateField
						name={
							AchFeesFields.OriginationLargeTransactionDiscountFee
								.name
						}
						label={`${AchFeesFields.OriginationLargeTransactionDiscountFee.displayName}, %`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeePercent}
						hideRequiredMark={isPaperApplication}
					/>
					<TemplateField
						name={AchFeesFields.NoticeOfChangeReturnFee.name}
						label={`${AchFeesFields.NoticeOfChangeReturnFee.displayName}, $`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeeCurrency}
						hideRequiredMark={isPaperApplication}
					/>
					<TemplateField
						name={AchFeesFields.AccountVerificationFee.name}
						label={`${AchFeesFields.AccountVerificationFee.displayName}, $`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeeCurrency}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<TemplateField
						name={AchFeesFields.MonthlyFee.name}
						label={`${AchFeesFields.MonthlyFee.displayName}, $`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeeCurrency}
						hideRequiredMark={isPaperApplication}
					/>
					<TemplateField
						name={AchFeesFields.OriginationDiscountFee.name}
						label={`${AchFeesFields.OriginationDiscountFee.displayName}, %`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeePercent}
						hideRequiredMark={isPaperApplication}
					/>
					<TemplateField
						name={AchFeesFields.StandardReturnFee.name}
						label={`${AchFeesFields.StandardReturnFee.displayName}, $`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeeCurrency}
						hideRequiredMark={isPaperApplication}
					/>
					<TemplateField
						name={AchFeesFields.ChargebackReturnFee.name}
						label={`${AchFeesFields.ChargebackReturnFee.displayName}, $`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeeCurrency}
						hideRequiredMark={isPaperApplication}
					/>

					<TemplateField
						name={AchFeesFields.AccountVerificationPlusFee.name}
						label={`${AchFeesFields.AccountVerificationPlusFee.displayName}, $`}
						placeholder="0.000000"
						placeholderClassName={placeholderClassName}
						{...validators.achFeeCurrency}
						hideRequiredMark={isPaperApplication}
					/>
				</Col>
			</Row>
		</FeeBlockContext.Provider>
	);
};

export default FeesAchFields;
